var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scp-kg" },
    [
      _c(
        "div",
        {
          staticClass: "scp-kg-pipeline",
          attrs: { "aria-label": "How CFDE KG search works" },
        },
        [
          _c("p", { staticClass: "scp-kg-pipeline-title" }, [
            _vm._v("How this search works"),
          ]),
          _c("ol", { staticClass: "scp-kg-pipeline-steps" }, [
            _vm._m(0),
            _vm._m(1),
            _vm._m(2),
            _vm._m(3),
            _vm._m(4),
            _vm._m(5),
            _c(
              "li",
              {
                staticClass: "scp-kg-pipeline-step",
                class: {
                  "scp-kg-pipeline-step--optional": !_vm.relevanceComplete,
                },
              },
              [
                _c("span", { staticClass: "scp-kg-pipeline-num" }, [
                  _vm._v("7"),
                ]),
                _c("span", { staticClass: "scp-kg-pipeline-text" }, [
                  _c("strong", [_vm._v("Relevance to hypothesis")]),
                  _vm._v(
                    " — optional LLM labels for how each evidence edge relates to the hypothesis. "
                  ),
                  !_vm.relevanceComplete
                    ? _c("span", { staticClass: "scp-kg-pipeline-guide" }, [
                        _vm._v(
                          "To run this step, open the Actions panel and choose "
                        ),
                        _c("em", [_vm._v("Classify CFDE KG relevance")]),
                        _vm._v(
                          " (it appears at the top of Next steps after the search finishes)."
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ]),
          _c("p", { staticClass: "scp-kg-pipeline-note" }, [
            _vm._v(
              " These three hops are independent evidence routes against digcfdekg — not a single chained path — using the parsed target gene and outcome (plus selected Factor disease context). "
            ),
          ]),
        ]
      ),
      _vm.blockedReason
        ? _c(
            "div",
            { staticClass: "scp-kg-callout", attrs: { role: "status" } },
            [_vm._v(_vm._s(_vm.blockedReason))]
          )
        : _vm.evidence
        ? [
            _vm.networkGraph && _vm.networkGraph.nodes.length
              ? _c("ScopeKgNetworkGraph", {
                  attrs: { graph: _vm.networkGraph },
                })
              : _vm._e(),
            _c("div", { staticClass: "scp-kg-coverage" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.evidence.coverage.kg) +
                  " — " +
                  _vm._s(_vm.evidence.coverage.scope) +
                  " "
              ),
            ]),
            _vm.selectedMechanismLine
              ? _c("div", { staticClass: "scp-kg-coverage" }, [
                  _vm._v(" " + _vm._s(_vm.selectedMechanismLine) + " "),
                ])
              : _vm._e(),
            _vm.relevanceLoading
              ? _c("div", { staticClass: "scp-kg-relevance-status" }, [
                  _c("span", { staticClass: "scp-kg-relevance-marker" }),
                  _vm._v(" Classifying relevance… "),
                ])
              : _vm._e(),
            _vm._l(_vm.evidence.routes, function (route) {
              return _c("div", { key: route.id, staticClass: "scp-kg-route" }, [
                _c("div", { staticClass: "scp-kg-route-head" }, [
                  _c("span", { staticClass: "scp-kg-route-title" }, [
                    _vm._v(
                      "Hop " + _vm._s(route.hop) + " · " + _vm._s(route.label)
                    ),
                  ]),
                ]),
                route.edges.length
                  ? _c("table", { staticClass: "scp-kg-table" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          _vm._l(_vm.columnsFor(route.id), function (col) {
                            return _c("th", { key: col.key }, [
                              _vm._v(_vm._s(col.label)),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.sortedEdges(route), function (edge, index) {
                          return _c(
                            "tr",
                            { key: index },
                            _vm._l(_vm.columnsFor(route.id), function (col) {
                              return _c(
                                "td",
                                {
                                  key: col.key,
                                  class: {
                                    "scp-kg-cell-wrap":
                                      col.key === "geneSetLabel",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.cellValue(edge, col.key)) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        }),
                        0
                      ),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "scp-kg-empty",
                        attrs: { role: "status" },
                      },
                      [
                        _c("div", { staticClass: "scp-kg-route-flag" }, [
                          _vm._v(
                            "Not found in " +
                              _vm._s(_vm.evidence.coverage.kg) +
                              " for this route."
                          ),
                        ]),
                        route.id === "factor"
                          ? _c(
                              "div",
                              { staticClass: "scp-kg-hop2-detail" },
                              [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v("Target gene queried:"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.hop2Detail.targetGene || "—") +
                                      " "
                                  ),
                                ]),
                                _c("p", [
                                  _c("strong", [
                                    _vm._v("Mechanism search text"),
                                  ]),
                                  _vm._v(
                                    " (used to fetch Factor candidates): " +
                                      _vm._s(
                                        _vm.hop2Detail.mechanismQuery || "—"
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "p",
                                  [
                                    _c("strong", [
                                      _vm._v("Factor candidates returned:"),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.hop2Detail.candidateCount) +
                                        " "
                                    ),
                                    _vm.hop2Detail.selectedCount
                                      ? [
                                          _vm._v(" · "),
                                          _c("strong", [
                                            _vm._v("Selected for Hop 2:"),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.hop2Detail.selectedCount
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm.hop2Detail.selectionRationale
                                  ? _c("p", [
                                      _c("strong", [
                                        _vm._v("Selection rationale:"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.hop2Detail.selectionRationale
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.hop2Detail.selectedFactors.length
                                  ? [
                                      _vm._m(6, true),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "scp-kg-hop2-factor-list",
                                        },
                                        _vm._l(
                                          _vm.hop2Detail.selectedFactors,
                                          function (factor) {
                                            return _c(
                                              "li",
                                              {
                                                key: factor.iri || factor.label,
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "scp-kg-hop2-factor-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        factor.label ||
                                                          "Unnamed factor"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                factor.cfdeDisease
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "scp-kg-hop2-factor-meta",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " · disease context: " +
                                                            _vm._s(
                                                              factor.cfdeDisease
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                factor.score != null
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "scp-kg-hop2-factor-meta",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " · score " +
                                                            _vm._s(
                                                              _vm.formatScore(
                                                                factor.score
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "scp-kg-hop2-note" },
                                        [
                                          _vm._v(" No "),
                                          _c("code", [_vm._v("geneToFactor")]),
                                          _vm._v(" edge was found between "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.hop2Detail.targetGene ||
                                                  "the target gene"
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " and these Factors in digcfdekg. "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm.hop2Detail.strategy ===
                                    "trait_label_join"
                                  ? _c(
                                      "p",
                                      { staticClass: "scp-kg-hop2-note" },
                                      [
                                        _vm._v(
                                          " No mechanism Factor was selected, so Hop 2 fell back to joining gene→Factor and trait→Factor by trait-label match "
                                        ),
                                        _vm.hop2Detail.traitCandidates.length
                                          ? [
                                              _vm._v(
                                                " (candidates: " +
                                                  _vm._s(
                                                    _vm.hop2Detail.traitCandidates.join(
                                                      "; "
                                                    )
                                                  ) +
                                                  ") "
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(
                                          " — that join also returned no edges. "
                                        ),
                                      ],
                                      2
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "scp-kg-hop2-note" },
                                      [
                                        _vm._v(
                                          " No mechanism Factors were available to query for gene→Factor sharing. "
                                        ),
                                      ]
                                    ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    ),
              ])
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-kg-pipeline-step" }, [
      _c("span", { staticClass: "scp-kg-pipeline-num" }, [_vm._v("1")]),
      _c("span", { staticClass: "scp-kg-pipeline-text" }, [
        _c("strong", [_vm._v("Mechanism candidates")]),
        _vm._v(
          " — semantically search for up to 25 CFDE KG Factors matching the hypothesis outcome"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-kg-pipeline-step" }, [
      _c("span", { staticClass: "scp-kg-pipeline-num" }, [_vm._v("2")]),
      _c("span", { staticClass: "scp-kg-pipeline-text" }, [
        _c("strong", [_vm._v("Select mechanisms")]),
        _vm._v(
          " — LLM picks 1–5 Factors most relevant to the hypothesis (not forced to fill five)"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-kg-pipeline-step" }, [
      _c("span", { staticClass: "scp-kg-pipeline-num" }, [_vm._v("3")]),
      _c("span", { staticClass: "scp-kg-pipeline-text" }, [
        _c("strong", [_vm._v("Hop 1")]),
        _vm._v(
          " — direct gene→trait associations for the target gene and outcome-related traits"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-kg-pipeline-step" }, [
      _c("span", { staticClass: "scp-kg-pipeline-num" }, [_vm._v("4")]),
      _c("span", { staticClass: "scp-kg-pipeline-text" }, [
        _c("strong", [_vm._v("Hop 2")]),
        _vm._v(" — gene→Factor links for the selected mechanisms"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-kg-pipeline-step" }, [
      _c("span", { staticClass: "scp-kg-pipeline-num" }, [_vm._v("5")]),
      _c("span", { staticClass: "scp-kg-pipeline-text" }, [
        _c("strong", [_vm._v("Hop 3")]),
        _vm._v(
          " — gene set membership where the gene's sets link to matching traits"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-kg-pipeline-step" }, [
      _c("span", { staticClass: "scp-kg-pipeline-num" }, [_vm._v("6")]),
      _c("span", { staticClass: "scp-kg-pipeline-text" }, [
        _c("strong", [_vm._v("Network")]),
        _vm._v(
          " — build the Gene / Gene set / Factor / Trait graph from confirmed edges"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Factors checked for gene→Factor sharing:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }